import { SerializableObject } from '../../common-react/core';

import { ResourceType } from '../other/search-resource-type.enum';

export class SearchResult extends SerializableObject {
    title: string;
    description: string;
    resourceType: ResourceType;
    resourceId: string;
}
